import { useReveal } from "../hooks";

const POINTS = [
  "You focus on fulfillment and quality. We handle brand representation and customer acquisition.",
  "No upfront fees, no retainers — our compensation is 100% tied to closed sales.",
  "Recruited, trained, and managed reps deployed under your brand within weeks.",
];

export const Editorial = () => {
  const [ref, inView] = useReveal(0.25);
  return (
    <section className="sec editorial" data-testid="editorial-section">
      <div className="container" ref={ref}>
        <div className="editorial-cols">
          <div className={`reveal ${inView ? "in" : ""}`}>
            <span className="eyebrow light">Why Swift</span>
            <h2 className="h-display">Accelerate your brand's growth with <em>Swift Marketing</em></h2>
            <p className="lead">
              We take on all the risk of building a sales force so you don't have to.
              If we don't sell, you don't pay.
            </p>
          </div>
          <div className={`editorial-points reveal d2 ${inView ? "in" : ""}`}>
            {POINTS.map((p, i) => (
              <div key={i} className="editorial-point">
                <span className="n">0{i + 1}</span>
                <p>{p}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

const SERVICES = [
  { t: "Partnerships", d: "We become your outsourced sales division — recruiting, deploying, and managing face-to-face teams that represent your brand across telecom, B2B, and residential markets." },
  { t: "Staff Training", d: "Battle-tested onboarding and field coaching that turns raw talent into consistent closers. Product knowledge, objection handling, and compliance built in from day one." },
  { t: "Executive Coaching", d: "For founders and sales leaders: pipeline design, compensation architecture, and go-to-market strategy backed by data from thousands of real conversations." },
];

export const Services = () => {
  const [ref, inView] = useReveal(0.2);
  return (
    <section className="sec" id="services" data-testid="services-section" ref={ref}>
      <div className="container">
        <div className={`reveal ${inView ? "in" : ""}`}>
          <span className="eyebrow">What we do</span>
          <h2 className="h-display">Three ways we put revenue on your board</h2>
        </div>
        <div className="services-grid">
          {SERVICES.map((s, i) => (
            <div key={i} className={`service-card reveal d${i + 1} ${inView ? "in" : ""}`} data-testid={`service-card-${i}`}>
              <span className="num">/ 0{i + 1}</span>
              <span className="arrow">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M7 17L17 7M7 7h10v10" /></svg>
              </span>
              <h3>{s.t}</h3>
              <p>{s.d}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
